module.exports = __webpack_public_path__ + "img/webmad-logo.c14c2df5.svg";